import React from 'react';
import classNames from 'classnames';

import styles from './FormBody.module.scss';

interface FormBodyProps {
  title?: string | null;
  className?: string;
}

const FormBody = ({ title, children, className }: React.PropsWithChildren<FormBodyProps>) => (
  <div className={classNames(styles.body, className)}>
    {title && <div className={classNames('subtitle_large', styles.subtitle)}>{title}</div>}
    {children}
  </div>
);

export default FormBody;
